import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=ae8d9dc8&"
import script from "./FormList.vue?vue&type=script&lang=ts&"
export * from "./FormList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae8d9dc8')) {
      api.createRecord('ae8d9dc8', component.options)
    } else {
      api.reload('ae8d9dc8', component.options)
    }
    module.hot.accept("./FormList.vue?vue&type=template&id=ae8d9dc8&", function () {
      api.rerender('ae8d9dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/FormList.vue"
export default component.exports